import NavigationModel from '../../../../../components/CustomNavigation/NavigationModel';

export default function InactiveStudentDataAnalyticsNavigation() {
  const phpNavigationUrl = process.env.REACT_APP_PHP_URL;
  // const cred = localStorage.getItem('cred');
  // const userId = cred ? JSON.parse(cred)?.profile?.userId : null;
  const redirectUrl = `${phpNavigationUrl}/student/inactive_students`;

  return (
    <NavigationModel redirectUrl={redirectUrl} title="Inactive Student Data Analytics" navigationTo={'Old Portal'} />
  );
}
